
import { isString, map, each, filter  } from 'lodash';
import { User } from '../user/user';
import { RecordLink } from '../record-link/record-link';
import { InpiFieldError } from '../inpi';


export class RecordField {
  name: string
  value: string

  // View model fields
  model: any
  control: any
  inpiFieldError?: InpiFieldError

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  toRecordFieldInput() {
    return {
      name: this.name,
      value: this.value
    };
  }

  get valid():boolean {
    
    if(this.model && this.model.is_name) {

      if(!isString(this.value)) {
        return false;
      }

      let trimmedName = this.value.trim();

      if(trimmedName.length > 200) {
        return false;
      }

      if(trimmedName.length === 0) {
        return false;
      }
    }

    return true;
  }

  selectDefaultValue() {
    // Select the first value in a list field
    if (this.model.input === 'list') {
      this.value = this.model.valuesList[0].id;
    }
    // Select '' for boolean field
    else if (this.model.input === 'boolean') {
      this.value = '';
    }
    else {
      this.value = '';
    }
  }
}


export class Record {
  id: string
  name: string
  fields: RecordField[] = []
  is_root: boolean

  links: RecordLink[] = []

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  version: number

  // View model fields
  model: any

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if(this.fields) {
      this.fields = map(this.fields, f => new RecordField(f));
    }

    if(this.links) {
      this.links = map(this.links, l => new RecordLink(l));
    }
  }

  get valid():boolean {
    
    // fields
    let fieldsValid = true;

    each(this.fields , field => {
      if(!field.valid) {
        fieldsValid = false;
      }
    });

    if(!fieldsValid) {
      return false;
    }

    return true;
  }

  /**
   * Returns the list of fields allowed by the model
   */
  get modelFields() {
    if(!this.model) {
      return [];
    }

    return filter(this.fields, field => {
      return this.model[field.name] !== undefined;
    });
  }

  toCreateRecordInput() {
    return {
      fields: map(this.modelFields, f => f.toRecordFieldInput())
    };
  }

  toUpdateRecordInput() {
    return {
      version: this.version,
      fields: map(this.modelFields, f => f.toRecordFieldInput())
    };
  }
}
